import application from '../../api/application'
// import lodash from 'lodash';

const state = {
  appName: '', // 应用标题
  content: '', // 短信内容
  appPlatform: ['ios'], // 签名通道：general[普通]/vip[免审]
  appType: '1', // 应用类型
  BundleId: '', // Bundle ID
  androidSignature: '', // 应用签名
  androidPackageName: '', // 应用签名
  RSAPublicKey: '' // RSA 公钥
};

const actions = {
  // 创建模板
  async createApplication ({ dispatch, commit }, payload) {
    const response = await application.createApplication(payload);
    if (response.status === 200) {
      return Promise.resolve(response.data);
    }
    return Promise.resolve('failure');
  }
};

const mutations = {
  'INIT_APPFORM': (state) => {
    state.id = null;
    state.appType = '1';
    state.appName = '';
    state.appPlatform = ['ios'];
    state.appIntroduction = '';
    state.BundleId = '';
    state.androidSignature = '';
    state.androidPackageName = '';
    state.RSAPublicKey = '';
  },
  'UPDATE_APP_PLATFORM': (state, payload) => {
    state.appPlatform = payload.value;
  },
  'UPDATE_APP_TYPE': (state, payload) => {
    state.appType = payload.value;
  },
  'UPDATE_APP_NAME': (state, payload) => {
    state.appName = payload.value;
  },
  'UPDATE_INTRODUCTION': (state, payload) => {
    state.appIntroduction = payload.value;
  },
  'UPDATE_BUNDLEID': (state, payload) => {
    state.BundleId = payload.value;
  },
  'UPDATE_SIGN_NAME': (state, payload) => {
    state.androidSignature = payload.value;
  },
  'UPDATE_PACKAGE_NAME': (state, payload) => {
    state.androidPackageName = payload.value;
  },
  'UPDATE_RSA_KEY': (state, payload) => {
    state.RSAPublicKey = payload.value;
  },
  'UPDATE_TEMPLATE_INFO': (state, payload) => {
    state.isEdit = payload.isEdit;
    state.appName = payload.appName;
    state.appIntroduction = payload.appIntroduction;
    state.appPlatform = payload.appPlatform;
    state.appType = payload.appType;
    state.BundleId = payload.BundleId;
    state.androidSignature = payload.androidSignature;
    state.androidPackageName = payload.androidPackageName;
    state.RSAPublicKey = payload.RSAPublicKey;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/createApplication.js